export default __webpack_public_path__ + "static/media/Animation-logo-jaune.8f320d68.gif";